<!-- Button -->
<button mat-icon-button [matMenuTriggerFor]="userActions" matTooltip="Account" class="header-icon-btn !h-10 !w-10">
  <img class="block aspect-square h-8 w-8 shrink-0 rounded-full object-cover" [src]="profile?.profile_image_url | avatar: profile?.full_name" [alt]="profile?.full_name" />
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu" class="user-panel">
  <!-- Profile header -->
  <div class="flex flex-col items-center px-4 py-4" (click)="$event.stopPropagation()">
    <img class="mb-2 h-16 w-16 rounded-full object-cover" [src]="profile?.profile_image_url | avatar: profile?.full_name" [alt]="profile?.full_name" />
    <p class="text-lg font-semibold text-gray-800">{{ profile?.full_name }}</p>
    <p class="text-sm text-gray-500">{{ profile?.role?.title }}</p>
    <p class="text-sm text-gray-400">{{ profile?.email }}</p>
  </div>

  <mat-divider class="my-1"></mat-divider>

  <a mat-menu-item routerLink="/profile">
    <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
    <span>My Profile</span>
  </a>
  <a mat-menu-item routerLink="/profile/my-activity-logs">
    <mat-icon [svgIcon]="'heroicons_outline:cog-8-tooth'"></mat-icon>
    <span>My Activity Logs</span>
  </a>
  <a mat-menu-item routerLink="/profile/my-access-logs">
    <mat-icon fontIcon="history"></mat-icon>
    <span>My Access Logs</span>
  </a>

  @if (profile?.company?.has_inspections) {
    <button mat-menu-item (click)="OpenSnagsPortal()">
      <mat-icon fontIcon="open_in_new"></mat-icon>
      <span>Snags Portal</span>
    </button>
  }

  @if (profile?.call_center_agent && profile?.company?.has_call_center) {
    <button mat-menu-item (click)="OpenCallCenterPortal()">
      <mat-icon fontIcon="open_in_new"></mat-icon>
      <span>Call Center Portal</span>
    </button>
  }

  <mat-divider class="my-1"></mat-divider>

  <button mat-menu-item (click)="logout()" [disabled]="loading > 0">
    <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
    <span>Sign out</span>
  </button>
</mat-menu>
